/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'basket-accept': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<path pid="0" d="M10.243.293a1 1 0 010 1.414l-5.95 5.95-4-4a1 1 0 011.414-1.414l2.585 2.585L8.828.293a1 1 0 011.415 0z" _fill="#000" fill-rule="evenodd"/>'
  }
})
